var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgBuild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3182 7.39648L7.52777 11.2854V21.7955H15.2601V11.3409L11.3182 7.39648Z",
    fill: "#50B6E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8005 9.89895H15.5631L11.3182 5.95703L7.52777 9.74996V11.2853L11.3182 7.39643L15.2601 11.3409V21.7954H22.8005V9.89895Z",
    fill: "#238FC4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3182 5.95703H19.2904L22.8535 9.89895H15.5631L11.3182 5.95703Z",
    fill: "#2F2411"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1869 12.5884H10.5581V14.2172H12.1869V12.5884Z",
    fill: "#238FC4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5631 11.649L18.5656 17.7248H24.5631V11.649Z",
    fill: "#68382A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5252 17.7248H24.5631V11.649L30.5252 17.7248Z",
    fill: "#2F2411"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5252 17.7249H18.5656V28.4269H30.5252V17.7249Z",
    fill: "#128D50"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.303 22.0985C27.9264 22.0985 28.4318 21.5931 28.4318 20.9697C28.4318 20.3463 27.9264 19.8409 27.303 19.8409C26.6796 19.8409 26.1742 20.3463 26.1742 20.9697C26.1742 21.5931 26.6796 22.0985 27.303 22.0985Z",
    fill: "#2F2411"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1591 18.4849L22.0606 20.5278V28.4268H24.6894V18.4849H20.1591Z",
    fill: "#8ABE66"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28282 18.197L1.44696 22.1314V28.4268H9.22221V22.1415L5.28282 18.197Z",
    fill: "#F7C3C7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1212 20.697H9.52524L5.28282 16.7576L1.44696 20.5934V22.1313L5.28282 18.197L9.22221 22.1414V28.4268H21.1212V20.697Z",
    fill: "#F38772"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28281 16.7576H17.6111L21.1742 20.697H9.52523L5.28281 16.7576Z",
    fill: "#2F2411"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1439 23.3131H12.3636V25.0934H14.1439V23.3131Z",
    fill: "#2F2411"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6136 23.3131H16.8333V25.0934H18.6136V23.3131Z",
    fill: "#2F2411"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14899 23.3889H4.5202V25.0177H6.14899V23.3889Z",
    fill: "#F38772"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBuild);
export default __webpack_public_path__ + "static/media/img-build.9b27308f5df238b743ec9be4fca3bb29.svg";
export { ForwardRef as ReactComponent };